import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Retainers() {
  const plans = [{
    name: 'Starter',
    hours: '10 hours / month',
    price: '$949',
    rate: '$95/hour',
    features: ['Access to full team', 'Use for any service', '24-48hr response', 'Slack + email access'],
    cta: 'Get Started',
    highlight: false
  }, {
    name: 'Growth',
    hours: '20 hours / month',
    price: '$1,599',
    rate: '$80/hour',
    features: ['Everything in Starter', 'Same-day response', 'Weekly async check-in', '1 strategy call / month'],
    cta: 'Get Started',
    highlight: true
  }, {
    name: 'Scale',
    hours: '30 hours / month',
    price: '$2,149',
    rate: '$72/hour',
    features: ['Everything in Growth', 'Dedicated Slack channel', '2 strategy calls / month', 'Same-day turnaround'],
    cta: 'Get Started',
    highlight: false
  }];
  return <section id="retainers" className="py-24 bg-[#1a1a1a] text-white" data-id="element-112">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-114">
          <span className="text-[#D4A088] font-medium tracking-[0.2em] uppercase text-xs mb-4 block" data-id="element-115">
            Monthly Retainers
          </span>
          <h2 className="text-5xl md:text-6xl font-serif text-white mb-6 font-normal" data-id="element-116">
            Ongoing access. Maximum flexibility.
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto font-normal" data-id="element-117">
            Buy hours, use them for anything. Your on-demand team for everything
            you need.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto items-start" data-id="element-118">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative" data-id="element-119">
              {plan.highlight && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white text-[#1a1a1a] text-xs font-bold uppercase tracking-wider py-1.5 px-4 rounded-sm" data-id="element-120">
                  Most Popular
                </div>}

              <div className={`rounded-lg p-8 h-full flex flex-col ${plan.highlight ? 'bg-[#B8704F]' : 'bg-[#2a2a2a] border border-white/10'}`} data-id="element-121">
                <div className="mb-8" data-id="element-122">
                  <h3 className={`text-2xl font-serif mb-2 font-normal ${plan.highlight ? 'text-white' : 'text-white'}`} data-id="element-123">
                    {plan.name}
                  </h3>
                  <div className={`text-sm mb-6 ${plan.highlight ? 'text-white/80' : 'text-white/60'}`} data-id="element-124">
                    {plan.hours}
                  </div>
                  <div className="flex items-baseline gap-1 mb-1" data-id="element-125">
                    <span className="text-5xl font-serif font-normal text-white" data-id="element-126">
                      {plan.price}
                    </span>
                    <span className={`text-lg ${plan.highlight ? 'text-white/80' : 'text-white/60'}`} data-id="element-127">
                      /mo
                    </span>
                  </div>
                  <div className={`text-sm ${plan.highlight ? 'text-white/80' : 'text-white/60'}`} data-id="element-128">
                    {plan.rate}
                  </div>
                </div>

                <ul className="space-y-4 mb-8 flex-1" data-id="element-129">
                  {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-130">
                      <Check className={`w-5 h-5 mr-3 flex-shrink-0 ${plan.highlight ? 'text-white' : 'text-white/80'}`} data-id="element-131" />
                      <span className={`text-sm ${plan.highlight ? 'text-white/90' : 'text-white/70'}`} data-id="element-132">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <a href="#contact" className={`block text-center py-3.5 font-medium transition-colors ${plan.highlight ? 'bg-[#1a1a1a] text-white hover:bg-black' : 'bg-white text-[#1a1a1a] hover:bg-white/90'}`} data-id="element-133">
                  {plan.cta}
                </a>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center text-white/50 text-sm" data-id="element-134">
          <p data-id="element-135">Need more hours? Add-ons available. All plans cancel anytime.</p>
        </div>
      </div>
    </section>;
}